import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { StatusReasonDialog } from './StatusReasonDialog';

/**
 * Reactivate-user confirmation dialog (AUT-124). Collects a required
 * reason and resolves it to the parent, which routes the PATCH through
 * the TOTP step-up. Restorative variant (green confirm).
 */
export interface ReactivateUserDialogProps {
  open: boolean;
  loading?: boolean;
  onConfirm: (reason: string) => void;
  onCancel: () => void;
}

export const ReactivateUserDialog = ({
  open,
  loading,
  onConfirm,
  onCancel,
}: ReactivateUserDialogProps): ReactElement => {
  const { t } = useTranslation();
  return (
    <StatusReasonDialog
      open={open}
      title={t('users.reactivateDialog.title')}
      description={t('users.reactivateDialog.description')}
      reasonLabel={t('users.reactivateDialog.reasonLabel')}
      reasonRequiredKey="users.reactivateDialog.reasonRequired"
      reasonMaxKey="users.reactivateDialog.reasonMax"
      confirmLabel={t('users.reactivateDialog.confirm')}
      color="success"
      {...(loading !== undefined ? { loading } : {})}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
